import ratePlanSimulationApi from '@/api/ratePlanSimulation/ratePlanSimulationApi'

export default {
    name: 'rate-plan-calculation',
    mixins: [],
    extends: {},
    components: {},
    props: [],
    data() {
        return {
            SELECT_LIMIT: 5,
            flag:'',
            selectedvId:[-1], // 預設選擇 目前資費
            selectedvdId:[-1], // 預設選擇 目前資費
            vminRPC:'',
            vdminRPC:'',
            vchart:'',
            vdchart:'',
            getRatePlanCalculationResp:{
                isNotDefinition:'',
                vratePlanCalculations:[
                    {
                        calculations:'',
                    }
                ],
                vdratePlanCalculations:[
                    {
                        calculations:'',
                    }
                ],
            },
        };
    },
    computed: {
    },
    watch: {},
    created() {

    },
    mounted() {
        this.init();
    },
    updated() {},
    beforeDestroy() {},
    methods: {
        async init() {

            this.flag = this.$route.query.flag;

            let flags = ['v', 'vd'];
            let defaultFlag = flags[0];
            if (!this.flag || flags.indexOf(this.flag) == -1) {
                this.flag = defaultFlag;
            }

            this.getRatePlanCalculationResp = await ratePlanSimulationApi.getRatePlanCalculation();

            if (this.getRatePlanCalculationResp.isNotDefinition) {
                return;
            }

            this.vchart = this.getRatePlanCalculationResp.vbase64Image;
            this.vdchart = this.getRatePlanCalculationResp.vdBase64Image;

            // 按ruleId由小到大排列費率
            this.sortByRuleIdAsc(this.getRatePlanCalculationResp.vratePlanCalculations);
            this.sortByRuleIdAsc(this.getRatePlanCalculationResp.vdratePlanCalculations);

            // 按月份由遠到近
            // 純語音費率
            for (let i in this.getRatePlanCalculationResp.vratePlanCalculations) {
                this.sortByMonthAsc(this.getRatePlanCalculationResp.vratePlanCalculations[i].calculations);
            }
            // 語音數據費率
            for (let i in this.getRatePlanCalculationResp.vdratePlanCalculations) {
                this.sortByMonthAsc(this.getRatePlanCalculationResp.vdratePlanCalculations[i].calculations);
            }

            // 篩選出Sum最小的ratePlanCalculation
            // 並預設為勾選
            this.vminRPC = this.filterMinSum(this.getRatePlanCalculationResp.vratePlanCalculations);
            this.selectedvId.push(this.vminRPC.ruleId);
            this.vdminRPC = this.filterMinSum(this.getRatePlanCalculationResp.vdratePlanCalculations);
            this.selectedvdId.push(this.vdminRPC.ruleId);
        },

        async getVChart() {
            let payload = {
                ruleIds: this.selectedvId,
                flag: 'V',
            }
            let resp = await ratePlanSimulationApi.getRatePlanChart(payload);
            this.vchart = resp.base64Image;
        },

        async getVDChart() {
            let payload = {
                ruleIds: this.selectedvdId,
                flag: 'VD'
            }
            let resp = await ratePlanSimulationApi.getRatePlanChart(payload);
            this.vdchart = resp.base64Image;
        },

        changeTab(f) {
            this.flag = f;
        },

        filterMinSum(ratePlanCalculations) {
            // 預設篩選出 ruleId = -1（目前資費） 以外的項目
            let minSumRPC = null;
            for (let i in ratePlanCalculations) {
                let rpc = ratePlanCalculations[i];
                if (rpc.ruleId == -1) {
                    continue;
                }
                if (minSumRPC == null || rpc.sum < minSumRPC.sum) {
                    minSumRPC = rpc;
                }
            }
            return minSumRPC;
        },

        getImgSrc(data) {
            return 'data:image/png;base64,' + data;
        },

        sortByMonthAsc(calArr) {
            calArr.sort(function(c1, c2){
				return c1.month - c2.month;
			});
        },

        sortByRuleIdAsc(rpcArr) {
            rpcArr.sort(function(rpc1, rpc2){
				return rpc1.ruleId - rpc2.ruleId;
			});
        }
    },
};


// WEBPACK FOOTER //
// ./src/components/ratePlanSimulation/ratePlanCalculation.js